import { render } from "./InputReference.vue?vue&type=template&id=183c6990&scoped=true"
import script from "./InputReference.vue?vue&type=script&lang=ts"
export * from "./InputReference.vue?vue&type=script&lang=ts"

import "./InputReference.vue?vue&type=style&index=0&id=183c6990&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-183c6990"

export default script